import { apiSetup, fetchShopifyCurrencyCode } from '../utils/config/factory';
import { state } from '../utils/store/store';

apiSetup();

fetchShopifyCurrencyCode().then(code => {
  state.setCurrencyCode(code);
});